import { ListItemType, RepeaterListProps } from "./List.types";

/**
 * A list component that renders a list of items without any parent container.
 * 
 * @template T - The type of the list item.
 * @param {RepeaterListProps<T>} props - The properties for the repeater list.
 * @returns {JSX.Element} The rendered repeater list.
 */
const RepeaterList = <T extends ListItemType>(props: RepeaterListProps<T>) => {
  const {
    data,
    component: Component,
  } = props;

  return (
    <>
      {data?.map((item, index) => (
        <Component key={index} {...item} />
      ))}
    </>
  )
}

export default RepeaterList;